@if (fabrikat.id) {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Rediger fabrikat</h1>
}
@if (!fabrikat.id) {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Opret fabrikat</h1>
}
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Produkt</mat-label>
        <mat-select formControlName="produktId">
          @for (produkt of produkter; track produkt) {
            <mat-option [value]="produkt">{{ produkt }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Navn</mat-label>
        <input formControlName="name" matInput />
      </mat-form-field>
    </div>

    <div class="form-row no-margin-bottom">
      <mat-form-field appearance="outline">
        <mat-label>Tillad oprettelse</mat-label>
        <mat-select formControlName="fabrikatstatus">
          @for (status of fabrikatstatus; track status) {
            <mat-option [value]="status.value">{{ status.name }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close="">Fortryd</button>
  <button [disabled]="!form.valid" mat-raised-button color="primary" (click)="update()">Gem</button>
</div>
